import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Tooltip from '../../../shared/Tooltip';
import Text from '../../../shared/Text';
import Button from '../../../shared/Button';
import { Modal } from '../../boardSetup/components/Modals/Modal';
import { ShareLinkModal } from './ShareLinkModal';

export const Navbar = ({ campaigns }) => {
  const { t } = useTranslation('moments');
  const isPublic = useSelector(state => state.currentBoard.isPublic);
  const [showModal, setShowModal] = useState(false);

  const onBackBtnClick = () => {
    const mixpanelData = {
      userName: window.Airbo.Utils.currentUser().user_name,
      boardName: window.Airbo.Utils.currentBoard().name,
    };

    window.Airbo.Utils.ping('User clicked Moments Back button', mixpanelData);
    window.history.back();
  };

  return (
    <>
      <Tooltip />
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <ShareLinkModal
          campaigns={campaigns}
          onClose={() => setShowModal(false)}
        />
      </Modal>
      <Container>
        <div>
          <Button mode="text" variant="black" onClick={onBackBtnClick}>
            <LeftArrow />
            {t('nav.back')}
          </Button>
        </div>
        <CenterTextContainer>
          <Text variant="h5">{t('nav.centerText')}</Text>
        </CenterTextContainer>
        <ShareLinkContainer>
          <ShareBtn
            $isPublic={isPublic}
            width="134px"
            mode="outline"
            variant="black"
            onClick={() => {
              if (!isPublic) return;
              setShowModal(true);
            }}
            data-tip={isPublic ? '' : t('nav.makePublic')}
          >
            <ShareIcon />
            {t('nav.shareLink')}
          </ShareBtn>
        </ShareLinkContainer>
      </Container>
    </>
  );
};

Navbar.propTypes = {
  campaigns: PropTypes.array,
};

const Container = styled.div`
  background: ${themeGet('colors.background')};
  margin: 0 10px;
  padding: 10px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  position: sticky;
  align-items: center;
  z-index: 3;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  justify-content: end;
`;

const ShareLinkContainer = styled.div`
  display: flex;
  justify-content: end;
`;

const CenterTextContainer = styled.div`
  text-align: center;
`;

const ShareBtn = styled(Button)`
  cursor: ${props => (props.$isPublic ? 'cursor' : 'not-allowed')};
  opacity: ${props => (props.$isPublic ? '1' : '0.5')};
`;

const ShareIcon = styled.i.attrs({
  className: 'fa-light fa-share fa-lg',
})`
  margin-right: 6px;
`;

const LeftArrow = styled.i.attrs({
  className: 'fa-regular fa-chevron-left',
})`
  margin-right: 6px;
`;
